import { combineReducers, ReducersMapObject } from '@reduxjs/toolkit';
import { authReducer } from '@ovpn-ui-toolkit/mf-common';
import { notificationsReducer } from '@cloud/shared';

const rootReducers = {
    auth: authReducer,
    notifications: notificationsReducer,
};

export default function createReducer(injectedReducers: ReducersMapObject = {}) {
    return combineReducers({
        ...rootReducers,
        ...injectedReducers,
    });
}
